export enum MenuItems {
    DASHBOARD = 'DASHBOARD',
    LISTING = 'LISTING',
    OPERATORS = 'OPERATORS',
    ADMINS = 'ADMINS',
    USERS = 'USERS',
    INVOICEAMOUNT = 'INVOICEAMOUNT',
}